import { render } from "./SiteNavbar.vue?vue&type=template&id=588133d0&scoped=true"
import script from "./SiteNavbar.vue?vue&type=script&lang=js"
export * from "./SiteNavbar.vue?vue&type=script&lang=js"

import "./SiteNavbar.vue?vue&type=style&index=0&id=588133d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588133d0"]])

export default __exports__